import { Link } from 'react-router-dom';
import { Icon } from '@/components/common/Icon';

export function WelcomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-950 via-emerald-900 to-emerald-800 text-white">
      <header className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <BrandBadge />
          <div>
            <p className="text-xs uppercase tracking-wide text-[rgb(110,231,183)]">
              Chrome Extension
            </p>
            <p className="text-xl font-semibold">ATS CV Checker</p>
          </div>
        </div>
        <nav className="hidden md:flex items-center gap-6 text-sm text-emerald-100">
          <Link className="hover:text-white transition-colors" to="/home">
            Home
          </Link>
          <Link className="hover:text-white transition-colors" to="/contact">
            Contact us
          </Link>
        </nav>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-10 space-y-8">
        <section className="space-y-4 text-center">
          <h1 className="text-4xl sm:text-5xl font-black leading-tight flex items-center justify-center gap-3 drop-shadow-sm">
            <Icon name="sparkles" size={40} className="text-yellow-400" />
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-emerald-50 to-white">
              Now you have a great way to build an ATS-ready CV
            </span>
          </h1>
          <p className="text-xl text-emerald-50 font-medium">
            Pin the extension for quick access to the ATS CV Checker.
          </p>
        </section>

        <section className="space-y-5">
          <div className="space-y-3 text-center">
            <p className="text-sm font-semibold">
              1. Pin the extension for quick access to the ATS CV Checker.
            </p>
            <div className="relative w-full overflow-hidden rounded-xl">
              <img
                src="/welcome1.webp"
                alt="Pin the ATS CV Checker extension in Chrome"
                className="w-[60%] h-auto block mx-auto"
              />
            </div>
          </div>

          <div className="space-y-3 text-center">
            <p className="text-sm font-semibold">
              2. Simply click on the extension icon to open the converter.
            </p>
            <div className="relative w-full overflow-hidden rounded-xl">
              <img
                src="/welcome-2.webp"
                alt="Click the ATS CV Checker extension icon"
                className="w-[60%] h-auto block mx-auto"
              />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

function BrandBadge() {
  return (
    <div className="w-12 h-12 rounded-2xl bg-white flex items-center justify-center shadow-lg border border-emerald-200">
      <img src="/ats-icon.png" alt="ATS CV Checker logo" className="w-10 h-10 object-contain" />
    </div>
  );
}
